// extracted by mini-css-extract-plugin
export var linkText = "_pi-0";